<onyx-section
  [heading]="`${I18N}.assignedVehicles`"
  [count]="vehiclesControl.length"
>
  <div class="container">
    <onyx-toggle
      [label]="`${I18N}.assignAll`"
      [(checked)]="assignAllVehicles"
      (click)="assign()"
    ></onyx-toggle>

    <form [formGroup]="form()">
      <onyx-dropdown
        [formControl]="form().controls.selectedVehicles"
        [options]="VEHICLES_SOURCE"
        [multiple]="true"
        (totalItemsChange)="totalVehiclesCount.set($event)"
        (selectedOptionValuesChange)="vehicles.set($event.values)"
        [size]="32"
      ></onyx-dropdown>

      <onyx-table
        [data]="vehiclesList()"
        [columns]="COLUMNS"
        [tableShadow]="false"
        [rowSize]="48"
        [notFound]="NOT_FOUND"
        (rowClick)="openVehicleModal($event.item)"
        [(pagination)]="pagination"
      ></onyx-table>
    </form>
  </div>
</onyx-section>
